export default {
  buttons: {
    save: 'Salva',
    confirm: 'Conferma',
    cancel: 'Annulla',
  },
  confirmation: {
    title: 'Vuoi davvero sincronizzare con i servizi esterni?',
  },
};
